import chunk from 'chunk'
import qr from 'qr-image'

export const genLabel = (data) => {
  const createLabel = (label) => {
    const json = {
      app: 'thairun.item',
      productId: label.productId,
      itemId: label.itemId,
    }
    return `
<td class="main-cell">
  <div class="label">
    <div class="qrcode">
      ${qr.imageSync(JSON.stringify(json), { type: 'svg' })}
      <span class="label-id">${label.itemId}<span>
    </div>
    <div class="label-desc">
      <span>${label.name}<br>${label.size}<br>${label.color}</span>
    </div>
  </div>
</td>`
  }
  const createRow = row => `
<tr>
  ${row.map(label => createLabel(label)).join('\n')}
</tr>`
  const createPage = labels => `
<table>
  ${chunk(labels, 2).map(row => createRow(row)).join('\n')}
</table>`

  const html = `
<html>
  <style>
    @import url('https://fonts.googleapis.com/css?family=Kanit');
    body{
      margin: 0px;
      font-family: 'Kanit', sans-serif;
    }
    td {
      vertical-align: top;
      text-align: left;
      font-size: 12px;
      /*border: 0.001in solid black;*/
    }
    table {
      width: -webkit-fill-available;
      page-break-after: always;
      margin: 1mm 2mm;
      border-collapse: collapse;
      width: 104mm;
    }
    .main-cell {
      max-width: 50mm;
      width: 50mm;
      max-height: 27mm;
      height: 27mm;
      position: relative;
      padding: 1.5mm;
      overflow: hidden;
    }
    .label {
      display: flex;
    }
    .qrcode {
      width: 20mm;
      height: 23mm;
      background: #fff;
      text-align: center;
    }
    .qrcode .label-id {
      font-size: 9px;
    }
    .label-desc {
      width: 26mm;
      height: 23mm;
      display: flex;
    }
    .label-desc span {
      align-self: center;
      flex: auto;
      text-align: center;
    }
  </style>
  <body>
    ${chunk(data, 2).map(page => createPage(page)).join('\n')}
  </body>
</html>
`
  return html
}

export default {
  genLabel,
}



// WEBPACK FOOTER //
// ./src/helpers/item.js